import React from 'react';
import "../../../assets/css/QuickStats.css"
import "../../../assets/css/TicketsOverview.css"
import CurrentlyBeingServed from "./quickInfo/CurrentlyBeingServed"
import QuickStats from "./quickInfo/QuickStats"
import QuickAlerts from "./quickInfo/QuickAlerts"
import TicketList from "./quickInfo/TicketList"

const QuickInfo = () => {

    return (
            <div className="quickInfo">
                <QuickAlerts />

                <div className="quickStats">
                    <h5>Quick Stats</h5>
                    <QuickStats />
                </div>
                
                <div className="ticketsOverview">
                    <h5>Customers Overview</h5>
                    <CurrentlyBeingServed />
                    <TicketList />
                </div>


            </div>
        )
}

export default QuickInfo;

